// Back to top 

// Get the button:
const backToTop = document.querySelector('.back-to-top');
if (backToTop) {
  window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
      backToTop.classList.add('back-to-top--is-visible');
    } else {
      backToTop.classList.remove('back-to-top--is-visible');
    }
  });
  backToTop.addEventListener('click', topFunction);
  document.querySelector('html').classList.add('article__page');
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}